import {http} from './config';

export default {
    index: (filter, page = 1, index = false) => {
        if (index){
            return http.get('api/v1/configEmpresa', {params: {page: page,filter}});
        }
        return http.get('api/v1/configEmpresa', {params: filter});
    },
    show: (id) => {
        return http.get(`api/v1/configEmpresa/${id}`);
    },
    update: (data) => {
        return http.put(`api/v1/configEmpresa/${data.id}`, {
            plan_id: data.plan.id,
            can_show_info_company_on_fich_client: data.can_show_info_company_on_fich_client,
            number_max_financial_movements_per_sale: data.number_max_financial_movements_per_sale,
            amount_max_per_billet: data.amount_max_per_billet,
            company_name: data.company_name,
            whatsapp_token: data.whatsapp_token,
            days_repentance: data.days_repentance,
            company_id: data.company_id,
            notify_reserve_create: !!data.notify_reserve_create,
            notify_reserve_confirmed: !!data.notify_reserve_confirmed,
            notify_reserve_derrubed: !!data.notify_reserve_derrubed,
            notify_reserve_renew: !!data.notify_reserve_renew,
            notify_reserve_indertemined: !!data.notify_reserve_indertemined,
            notify_reserve_expired: !!data.notify_reserve_expired,
            notify_proposal_create: !!data.notify_proposal_create,
            notify_create_client_public: !!data.notify_create_client_public,
            notify_reserve_client_belongs_anoter_broker: !!data.notify_reserve_client_belongs_anoter_broker,
        });
    }
}
